/* ========================================
   Knowing Look — kl-buy-block.js (DEV-020 Phase 4, 2026-09-11)
   The buy block's behaviour, once per [data-kl-bb] root (the In Demand
   section renders up to three): the View Design Closeup zoom/pan modal and
   the option pick -> variant resolve -> buy button flow.

   REWRITTEN (HOD G3), not lifted, from the two inline scripts of
   sections/featured-hero.liquid rev 2026-09-10 (:490-587 zoom, :600-724 buy)
   so nothing is Liquid-interpolated: the scope comes from data-kl-bb, the
   option count from data-kl-optcount, and every lookup walks from the root,
   never from document. Gone with their markup: the carousel arrows (6.84
   addendum) and the express/Shop Pay branch of paint() (the form went with
   the Shop Pay button, 6.84). Kept: the capture-phase buy gate - an
   incomplete pick opens the modal, and while data-kl-add is "" the shared
   quick-add handler steps aside (assets/kl-return-add.js:124-129); this
   script fills data-kl-add with the resolved variant id and that handler
   adds it (no form -> its own variant id, kl-return-add.js:132).
   ======================================== */
(function () {
  function initZoom(root) {
    var zoom = root.querySelector('[data-kl-bb-zoom]');
    if (!zoom) return;
    var scroller = zoom.querySelector('[data-kl-fh-zoomscroll]');
    var img = zoom.querySelector('.kl-fh-zoom__img');

    // 4.08: zoomed CSS width caps where 1 image px = 1 device px.
    function zoomWidth() {
      var fit = scroller.clientWidth;
      var native = img.naturalWidth / Math.min(window.devicePixelRatio || 1, 2);
      return Math.min(fit * 2, native);
    }
    function canZoom() { return img && img.naturalWidth > 0 && zoomWidth() > scroller.clientWidth * 1.05; }
    function setZoomed(w) {
      img.style.width = w + 'px';
      img.classList.add('kl-fh-zoom__img--zoomed');
    }
    function unzoom() {
      if (!img) return;
      img.style.width = '';
      img.classList.remove('kl-fh-zoom__img--zoomed');
    }
    // 4.06: zoom anchored so the clicked point stays under the cursor.
    function zoomAt(clientX, clientY) {
      var r = img.getBoundingClientRect();
      var relX = (clientX - r.left) / r.width;
      var relY = (clientY - r.top) / r.height;
      var w = zoomWidth();
      var h = w * (img.naturalHeight / img.naturalWidth);
      var sr = scroller.getBoundingClientRect();
      setZoomed(w);
      scroller.scrollLeft = relX * w - (clientX - sr.left);
      scroller.scrollTop = relY * h - (clientY - sr.top);
    }
    // 4.09: garment fallback opens framed on the print region.
    function openZoom() {
      zoom.hidden = false;
      document.body.classList.add('overflow-hidden');   // mobile audit 4 Oct 2026 F2: hold the page still, as the theme's modal-dialog does
      unzoom();
      if (scroller && scroller.dataset.klCloseupKind === 'garment') {
        var frame = function () {
          if (!canZoom()) return;
          var w = zoomWidth();
          var h = w * (img.naturalHeight / img.naturalWidth);
          setZoomed(w);
          scroller.scrollLeft = 0.5 * w - scroller.clientWidth / 2;
          scroller.scrollTop = 0.35 * h - scroller.clientHeight / 2;
        };
        if (img && img.naturalWidth > 0) frame();
        else if (img) img.addEventListener('load', frame, { once: true });
      }
    }

    // 4.07: drag pans; a drag suppresses the click that follows it.
    var drag = null, moved = false;
    if (scroller) {
      scroller.addEventListener('dragstart', function (e) { e.preventDefault(); });
      scroller.addEventListener('pointerdown', function (e) {
        if (!img || !img.classList.contains('kl-fh-zoom__img--zoomed')) return;
        e.preventDefault();
        drag = { x: e.clientX, y: e.clientY, left: scroller.scrollLeft, top: scroller.scrollTop };
        moved = false;
        scroller.classList.add('kl-fh-zoom__scroll--dragging');
        scroller.setPointerCapture(e.pointerId);
      });
      scroller.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (Math.abs(dx) > 5 || Math.abs(dy) > 5) moved = true;
        scroller.scrollLeft = drag.left - dx;
        scroller.scrollTop = drag.top - dy;
      });
      var endDrag = function () {
        drag = null;
        scroller.classList.remove('kl-fh-zoom__scroll--dragging');
      };
      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-kl-fh-expand]')) { openZoom(); return; }
      if (!zoom.hidden) {
        if (moved) { moved = false; return; }
        var hitImg = e.target.closest('.kl-fh-zoom__img');
        if (hitImg) {
          if (hitImg.classList.contains('kl-fh-zoom__img--zoomed')) unzoom();
          else if (canZoom()) zoomAt(e.clientX, e.clientY);
          return;
        }
        if (e.target === zoom || e.target.closest('[data-kl-bb-zoom] .kl-fh-modal__close')) { zoom.hidden = true; document.body.classList.remove('overflow-hidden'); unzoom(); }
      }
    });
  }

  function initBuy(root) {
    var dataEl = root.querySelector('script[data-kl-bb-variants]');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (err) { variants = []; }
    var optCount = parseInt(root.getAttribute('data-kl-optcount'), 10);
    if (!(optCount > 0)) optCount = 1;
    var sel = {};

    // B5/5.04: NO pre-selection - only single-value options auto-resolve.
    var metaEl = root.querySelector('script[data-kl-bb-optmeta]');
    var optMeta = [];
    try { optMeta = metaEl ? JSON.parse(metaEl.textContent) : []; } catch (err2) { optMeta = []; }
    for (var p0 = 0; p0 < optMeta.length; p0++) {
      if (optMeta[p0].count === 1) sel[p0 + 1] = optMeta[p0].value;
    }

    function resolve() {
      for (var p = 1; p <= optCount; p++) { if (!sel[p]) return null; }
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var p2 = 1; p2 <= optCount; p2++) {
          if (v['option' + p2] !== sel[p2]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    // The picture: a swatch pick JUMPS to that colour's mockup (no arrows).
    // Slides are static server-rendered nodes (nothing re-renders them).
    var slides = Array.prototype.slice.call(root.querySelectorAll('.kl-fh-slide'));
    function showSlide(i) {
      if (!slides.length) return;
      var n = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('kl-fh-slide--on', j === n); });
      root.dataset.klFhSlide = String(n);
    }
    function slideByMedia(mid) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-kl-media') === mid) return i;
      }
      return -1;
    }

    // Brent, 29 Sep 2026: the shirt opens on a RANDOM buyable colour. The pick is
    // normally made by the small script printed right after the pictures
    // (snippets/kl-buy-block.liquid — before first paint, so nothing flashes) and
    // marked data-kl-picked; this is the same pick for a block that arrived
    // without it (the theme editor re-rendering the section). Picture only:
    // nothing is selected (B5/5.04).
    function pickSlide() {
      var caro = root.querySelector('[data-kl-caro]');
      if (!caro || caro.getAttribute('data-kl-picked') === '1' || slides.length < 2) return;
      var ok = [];
      slides.forEach(function (s, j) { if (s.getAttribute('data-kl-avail') === '1') ok.push(j); });
      if (!ok.length) slides.forEach(function (s, j) { ok.push(j); });
      showSlide(ok[Math.floor(Math.random() * ok.length)]);
      caro.setAttribute('data-kl-picked', '1');
    }
    pickSlide();

    function paint() {
      root.querySelectorAll('.kl-fh-pill').forEach(function (pill) {
        var on = sel[pill.getAttribute('data-kl-opt')] === pill.getAttribute('data-kl-val');
        pill.classList.toggle('kl-fh-pill--on', on);
      });
      root.querySelectorAll('.kl-fh-sw').forEach(function (sw) {
        var on = sel[sw.getAttribute('data-kl-opt')] === sw.getAttribute('data-kl-val');
        sw.classList.toggle('kl-fh-sw--on', on);
      });
      var v = resolve();
      var vid = v ? String(v.id) : '';
      root.querySelectorAll('[data-kl-add]').forEach(function (b) { b.setAttribute('data-kl-add', vid); });
    }

    var modal = root.querySelector('[data-kl-bb-modal]');
    function openModal(missing) {
      paint();
      if (!modal) return;
      modal.querySelectorAll('.kl-fh-optrow').forEach(function (row) {
        row.classList.remove('kl-fh-optrow--missing');
      });
      var focusRow = null;
      (missing || []).forEach(function (p) {
        var row = modal.querySelector('.kl-fh-optrow[data-kl-optrow="' + p + '"]');
        if (row) { row.classList.add('kl-fh-optrow--missing'); if (!focusRow) focusRow = row; }
      });
      modal.hidden = false;
      if (focusRow) focusRow.scrollIntoView({ block: 'nearest' });
    }
    function closeModal() { if (modal) modal.hidden = true; }

    root.addEventListener('click', function (e) {
      var pick = e.target.closest('.kl-fh-pill, .kl-fh-sw');
      if (pick) {
        sel[pick.getAttribute('data-kl-opt')] = pick.getAttribute('data-kl-val');
        var mid = pick.getAttribute('data-kl-media');
        if (mid) { var si = slideByMedia(mid); if (si > -1) showSlide(si); }
        var row = pick.closest('.kl-fh-optrow');
        if (row) row.classList.remove('kl-fh-optrow--missing');
        paint();
        // B5/5.03: picking the LAST unresolved option in the modal submits
        // through the real buy button (canonical [data-kl-add] flow).
        if (modal && !modal.hidden && pick.closest('[data-kl-bb-modal]') && resolve()) {
          closeModal();
          var buyBtn = root.querySelector('[data-kl-add]');
          if (buyBtn) buyBtn.click();
        }
        return;
      }
      if (e.target.closest('[data-kl-bb-modal] .kl-fh-modal__close') || e.target === modal) { closeModal(); }
    });

    // Capture phase, on document: an unresolved click opens the modal and
    // stops there; kl-return-add.js sees data-kl-add "" and steps aside.
    document.addEventListener('click', function (e) {
      var buy = e.target.closest('[data-kl-add]');
      if (!buy || !root.contains(buy)) return;
      if (!resolve()) {
        e.preventDefault();
        e.stopPropagation();
        var missing = [];
        for (var p = 1; p <= optCount; p++) { if (!sel[p]) missing.push(p); }
        openModal(missing);
      }
    }, true);

    document.addEventListener('cart-drawer:open', closeModal);

    paint();
  }

  /* ---- Phase 7: the hover lift. The lift layer shows the current slide's
     picture at 2.05x; its width is capped to the 1340 band (the section's
     grid) and to the window less 8px a side, and shifted inward so it never
     leaves either. Recomputed on resize and after a swatch pick. ---- */
  function initLift(root) {
    var caro = root.querySelector('[data-kl-caro]');
    var lift = root.querySelector('[data-kl-lift]');
    if (!caro || !lift) return;
    var img = lift.querySelector('img');
    var grid = root.closest('[data-kl-id-grid]');
    // the LARGEST candidate of the current slide (its srcset / data-srcset), never
    // the 600px file the small slot picked — the lift is 861 wide, 1722 on retina
    function biggest(on) {
      var set = on.getAttribute('srcset') || on.getAttribute('data-srcset') || '';
      var best = '', bw = 0;
      set.split(',').forEach(function (c) {
        var m = c.trim().match(/^(\S+)\s+(\d+)w$/);
        if (m && parseInt(m[2], 10) > bw) { bw = parseInt(m[2], 10); best = m[1]; }
      });
      return best || on.currentSrc || on.getAttribute('data-src') || on.src || '';
    }
    function sync() {
      var on = caro.querySelector('.kl-fh-slide--on img');
      var src = on ? biggest(on) : '';
      if (!src) { lift.classList.remove('is-set'); return; }
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      lift.classList.add('is-set');
    }
    function measure() {
      if (window.innerWidth < 1100) { lift.style.removeProperty('--kl-liftw'); lift.style.setProperty('--kl-lifts', '0px'); return; }
      var g = grid ? grid.getBoundingClientRect() : { left: 0, right: window.innerWidth };
      var left = Math.max(g.left, 8), right = Math.min(g.right, window.innerWidth - 8);
      var r = caro.getBoundingClientRect(), w = Math.min(r.width * 2.05, right - left), cx = r.left + r.width / 2, sft = 0;
      var l = cx - w / 2, rt = cx + w / 2;
      if (l < left) sft = Math.ceil(left - l); else if (rt > right) sft = Math.floor(right - rt);
      lift.style.setProperty('--kl-liftw', Math.round(w) + 'px');
      lift.style.setProperty('--kl-lifts', sft + 'px');
    }
    root.addEventListener('pointerenter', function () { sync(); measure(); });
    caro.addEventListener('load', function () { if (lift.classList.contains('is-set')) sync(); }, true);
    root.addEventListener('click', function (e) { if (e.target.closest('.kl-fh-sw')) setTimeout(sync, 0); });
    var t = null;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(measure, 120); });
    sync(); measure();
  }

  /* ---- Phase 7: warm the close-up (lazy -> eager) the first time the pointer
     enters the block or the block scrolls into view, so the modal opens with
     the picture already fetched. Brent, 17 Sep (HOD N1): on a hover screen
     >= 1100px the close-up pill no longer exists (the hover lift is the
     close-up), so there is nothing to warm — skip the pre-load there and
     save three 1600px fetches. Same test as the pill's CSS. ---- */
  function initWarm(root) {
    var z = root.querySelector('[data-kl-closeup-img]');
    if (!z) return;
    if (window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 1100px)').matches) return;
    var done = false;
    function warm() { if (done) return; done = true; z.setAttribute('loading', 'eager'); z.setAttribute('fetchpriority', 'low'); }
    root.addEventListener('pointerenter', warm, { once: true });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { warm(); io.disconnect(); } }); }, { rootMargin: '200px' });
      io.observe(root);
    } else { warm(); }
  }

  function init(root) {
    if (root.dataset.klBbInit === '1') return;
    root.dataset.klBbInit = '1';
    initZoom(root);
    initBuy(root);
    initLift(root);
    initWarm(root);
  }
  function initAll() {
    document.querySelectorAll('[data-kl-bb]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // the theme editor re-renders a section in place
  document.addEventListener('shopify:section:load', initAll);
})();
